// Gudang Rido · Shopee/Tokopedia: tiga menu pekerjaan (Cari Barang kini global di atas tab). Badge "mendesak" hanya bila batas kirim < 24 jam.
import { useEffect, useState } from "react";
import axios from "axios";
import { Printer, Package, PackageSearch } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/shopee/direct/queue`;

function useDirectUrgent(active) {
  const [n, setN] = useState(0);
  useEffect(() => {
    let alive = true;
    axios.get(API, { withCredentials: true, timeout: 20000 })
      .then(r => { if (alive) setN((r.data?.unaccepted || []).filter(o => o.urgency === "red").length); })
      .catch(() => {});
    return () => { alive = false; };
  }, [active]);
  return n;
}

// HP: label pendek (short) + ikon kecil; desktop tetap judul + keterangan lengkap.
function Tile({ id, on, onClick, icon: I, title, sub, short, badge, extra = "" }) {
  return <button type="button" className={`rido-primary-tile ${extra} ${on ? "active" : ""}`} onClick={onClick} aria-pressed={on} aria-label={title} title={title} data-testid={id}>
    <span className="rido-primary-icon" aria-hidden="true"><I size={22}/></span>
    <span className="rido-primary-text"><strong><span className="rido-tile-full">{title}</span><span className="rido-tile-short" aria-hidden="true">{short}</span></strong><small>{sub}</small></span>
    {badge > 0 && <span className="rido-urgent-badge" data-testid={`${id}-urgent`}>{badge}<span className="rido-urgent-word"> mendesak</span></span>}
  </button>;
}

export function RidoShopeeTiles({ opSection, setOpSection }) {
  const urgent = useDirectUrgent(opSection);
  const print = opSection !== "direct" && opSection !== "stock";
  return <div className="rido-primary-strip rido-primary-strip-3" data-testid="rido-primary-strip-shopee" role="group" aria-label="Menu pekerjaan Gudang · Shopee">
    <Tile id="rido-primary-tile-direct-shopee" on={opSection === "direct"} onClick={() => setOpSection("direct")} icon={Package}
      title="Pesanan Tanpa Mockup" sub="Polosan · Biaya Tambahan / Layanan" short="Tanpa Mockup" badge={urgent} extra="rido-tile-direct"/>
    <Tile id="rido-primary-tile-print-shopee" on={print} onClick={() => setOpSection("prep")} icon={Printer} title="Cetak Mockup" sub="Belum / Sudah Dicetak" short="Cetak Mockup"/>
    <Tile id="rido-primary-tile-stock-shopee" on={opSection === "stock"} onClick={() => setOpSection("stock")} icon={PackageSearch}
      title="Pengecekan Stok Mockup" sub="Stok kurang / habis dari mockup" short="Cek Stok"/>
  </div>;
}
